import React from "react";
import "./Team.sass";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import Swiper core and required modules
import SwiperCore, { Pagination } from "swiper";

SwiperCore.use([Pagination]);

export default function Team() {
  const members = [
    {
      name: "Kana (Tokyo)",
      image: "/images/kana.png",
    },
    {
      name: "Mika (Merlin)",
      image: "/images/mika.png",
    },
    {
      name: "JOSHUA KEZZER",
      image: "/images/joshua.png",
    },
    {
      name: "JOHN (MEME)",
      image: "/images/josh.png",
    },
    {
      name: "Pixel Princess",
      image: "/images/pixel.png",
    },
    {
      name: "Olga (Madrid)",
      image: "/images/olga.png",
    },
    {
      name: "Ross (TechnoKing)",
      image: "/images/ross.png",
    },
  ];

  return (
    <div className="team">
      <h2
        className="team-title"
        style={{
          background: "url('/images/team-title-bg.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "contain",
        }}
      >
        Our Team
      </h2>
      <div className="team-members not-mobile">
        {members.map((member) => {
          return (
            <div className="team-member" key={member.name}>
              <div className="team-member-image">
                <img src={member.image} alt="" />
              </div>
              <div className="team-member-name">{member.name}</div>
            </div>
          );
        })}
      </div>
      <div className="team-members-mobile mobile">
        <Swiper
          slidesPerView={1.6}
          spaceBetween={30}
          centeredSlides={true}
          className="mySwiper"
          loop={true}
        >
          {members.map((member) => {
            return (
              <SwiperSlide key={member.name}>
                <div className="team-member">
                  <div className="team-member-image">
                    <img src={member.image} alt="" />
                  </div>
                  <div className="team-member-name">{member.name}</div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
